import { Stack } from '@mui/material';
import { type merged_time_and_activity } from 'common/@types/prisma';
import { YearChart } from './YearChart';
import { YearLegend } from './YearLegend';
import { type GradeTestData, PASSING_SCORE } from './constants';
import { type EdulasticTest } from 'common/@types/edulastic_data';

type LearningProgressProps = {
  lessonData: merged_time_and_activity[];
  testScoreData: EdulasticTest[];
};
export const LearningProgress = ({ lessonData, testScoreData }: LearningProgressProps) => {
  const lessons = formatLessons(lessonData);
  const grades = formatGrades(testScoreData);
  return (
    <Stack alignItems="center" gap="40px">
      <YearLegend />
      <YearChart lessons={lessons} grades={grades} />
    </Stack>
  );
};

function formatLessons(data: merged_time_and_activity[]): Array<{ date: Date }> {
  return data.map((lesson) => ({ date: new Date(lesson.date) }));
}

function formatGrades(testScores: EdulasticTest[]): GradeTestData[] {
  const gradeScores = testScores.reduce<Record<string, GradeTestData>>(
    (acc, { accuracy, grade: gradeNumber, startDate }) => {
      const grade = gradeNumber.toString();
      if (!acc[grade] || accuracy > acc[grade].highScore) {
        return {
          ...acc,
          [grade]: {
            highScore: accuracy,
            highScoreDate: new Date(startDate),
            name: grade,
          },
        };
      }
      return acc;
    },
    {}
  );
  return Object.values(gradeScores).filter(
    (grade) => !!grade && grade.highScore > PASSING_SCORE
  ) as GradeTestData[];
}
